import { useMemo } from 'react';
import type { ValueOf } from 'type-fest';

import type { CurrencySymbols } from '@hotjar/webapp/domains/common/settings/types';
import { useOwnedAccount } from '@hotjar/account';
import { useSettings } from '@hotjar/webapp/hooks/useSettings';

interface CurrencyData {
  code: keyof CurrencySymbols;
  symbol: ValueOf<CurrencySymbols>;
}

const defaultValue: CurrencyData = {
  code: 'eur',
  symbol: '€',
};

export function useOwnedAccountCurrency(): CurrencyData {
  const { data: settings } = useSettings();
  const { data: ownedAccount } = useOwnedAccount();

  return useMemo((): CurrencyData => {
    if (!settings || !ownedAccount) {
      return defaultValue;
    }

    return {
      code: ownedAccount.currency,
      symbol: settings.currency_symbols[ownedAccount.currency],
    };
  }, [settings, ownedAccount]);
}
